import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';  // Import the login-specific CSS

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // New loading state
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true); // Start loading

    try {
      const response = await fetch(`${process.env.REACT_APP_FQDN}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.access_token); // Store JWT in localStorage
        localStorage.setItem('username', username); // Store the username
        localStorage.setItem('refresh_token', data.refresh_token); // Store refresh token
        setLoading(false); // Stop loading
        navigate('/'); // Redirect to the homepage after successful login
      } else {
        setError(data.msg || 'Failed to login. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        {error && <p className="login-error-message">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="login-form-group">
            <label htmlFor="username" className="login-label">Email:</label>
            <input
              type="text"
              id="username"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="username"
              required
              disabled={loading} // Disable the field during loading
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="password" className="login-label">Password:</label>
            <input
              type="password"
              id="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
              required
              disabled={loading} // Disable the field during loading
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        {loading && <div className="login-spinner"></div>} {/* Display loading spinner */}

        <div className="login-forgot-password">
          <Link to="/request-password-reset">Forgot Password?</Link> {/* Link to the reset password page */}
          
        </div>
        <div className="login-forgot-password">
        <Link to="/register">Register</Link> {/* Link to the register page */}

        </div>
      </div>
    </div>
  );
}

export default Login;
